import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, forwardRef } from '@angular/core';
import { 
    IonIcon, InfiniteScrollCustomEvent, IonInfiniteScroll,  IonInfiniteScrollContent 
} from '@ionic/angular/standalone';

import { MarvTagComponent } from '@marv/components';
import { 
    OperationLogo, OperationLogoComponent, RetailerLogo, RetailerLogoComponent, PhotoGalleryItem, PhotoGalleryItemOperation, 
    PhotoGalleryItemStore, PhotoGalleryItemRetailer, PhotoGalleryItemComponent 
} from '@app/components';
import { Photo  } from '@app/models';
import { MissionTypeService, OperationService } from '@app/services';

class PhotoGroupStore{
    retailer: PhotoGalleryItemRetailer;
    store: PhotoGalleryItemStore;
    photos: Array<PhotoGalleryItem> = [];
    isOpened: boolean = true;
    constructor(retailer: PhotoGalleryItemRetailer, store: PhotoGalleryItemStore){
        this.retailer = retailer;
        this.store = store;
    }
}

class PhotoGroupOperation{
    operation: PhotoGalleryItemOperation;    
    stores: Map<string, PhotoGroupStore> = new Map<string, PhotoGroupStore>;
    isOpened: boolean = true;
    constructor(operation: PhotoGalleryItemOperation){
        this.operation = operation;
    }
}

@Component({
    selector: 'app-photo-gallery-group',
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.scss'],
    imports: [
        IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, forwardRef(() => MarvTagComponent), 
        forwardRef(() => OperationLogoComponent), forwardRef(() => RetailerLogoComponent), forwardRef(() => PhotoGalleryItemComponent)
    ]
})
export class PhotoGalleryGroupComponent  implements OnInit {

    @Input({alias : 'photos', required : false}) photos: Array<Photo> = [];   
    @Input({alias : 'size', required : false}) sizePhoto: 'small'|'medium'|'big' = 'medium';
    @Output() onSelectPhoto = new EventEmitter<PhotoGalleryItem>();
    
    photosGroups: Map<string, PhotoGroupOperation> = new Map<string, PhotoGroupOperation>();
    maxPhotosDisplayed: number = 100;
    indexPhotoDisplayed: number = 0;
    disabledInfiniteScroll: boolean = false;
    
    constructor(
        public missionTypeService: MissionTypeService
    ) { }

    ngOnInit() {}
    
    async ngOnChanges(changes: SimpleChanges) {        
        if(changes['photos'] && changes['photos'].currentValue){
            this.photosGroups.clear();
            this.indexPhotoDisplayed = 0;
            this.disabledInfiniteScroll = false;
            this.getPhotosDisplayed();
        }
    }
    
    getPhotosDisplayed(){  
        let subArray = this.photos.slice(this.indexPhotoDisplayed, this.indexPhotoDisplayed+this.maxPhotosDisplayed);
        if(subArray.length > 0){
            for(let p of subArray){
                let photoItem = PhotoGalleryItem.FromPhoto(p);
                let keyOperation = photoItem.operation.source+'|'+photoItem.operation.id;
                let photoGroupOperation = this.photosGroups.get(keyOperation);
                if(!photoGroupOperation){
                    photoGroupOperation = new PhotoGroupOperation(photoItem.operation);
                }

                let keyStore = photoItem.store.code;
                let photoGroupStore = photoGroupOperation.stores.get(keyStore);
                if(!photoGroupStore){
                    photoGroupStore = new PhotoGroupStore(photoItem.retailer, photoItem.store);
                }

                photoGroupStore.photos.push(photoItem);
                photoGroupOperation.stores.set(keyStore, photoGroupStore);
                this.photosGroups.set(keyOperation, photoGroupOperation);
            }
            this.indexPhotoDisplayed += subArray.length;
        }
        else{
            this.disabledInfiniteScroll = true;
        }
        
    }
    
    getOperationLogo(operation: PhotoGalleryItemOperation): OperationLogo{
        let op = OperationService.Operations.find(o => o.type === operation.source && o.id === operation.id);
        return new OperationLogo(operation.name, op?.operationLogoUrl);
    }
    
    getRetailerLogo(retailer: PhotoGalleryItemRetailer): RetailerLogo{
        return new RetailerLogo(retailer.name);
    }
    
    toggleOperation(operation: PhotoGalleryItemOperation) {
        let keyOperation = operation.source+'|'+operation.id;
        let photoGroupOperation = this.photosGroups.get(keyOperation);
        if(photoGroupOperation){
            photoGroupOperation.isOpened = !photoGroupOperation.isOpened;
            this.photosGroups.set(keyOperation, photoGroupOperation);
        }
    }
    
    toggleStore(operation: PhotoGalleryItemOperation, store: PhotoGalleryItemStore) {
        let keyOperation = operation.source+'|'+operation.id;
        let photoGroupOperation = this.photosGroups.get(keyOperation);
        if(photoGroupOperation){
            let keyStore = store.code;
            let photoGroupStore = photoGroupOperation.stores.get(keyStore);
            if(photoGroupStore){
                photoGroupStore.isOpened = !photoGroupStore.isOpened;
                photoGroupOperation.stores.set(keyStore, photoGroupStore);
                this.photosGroups.set(keyOperation, photoGroupOperation);
            }
        }
    }
    
    onIonInfinite(event: InfiniteScrollCustomEvent) { 
        this.getPhotosDisplayed();
        event.target.complete();
    }    

    selectPhoto(photo: PhotoGalleryItem){
        this.onSelectPhoto.emit(photo);
    }
}
